import React from "react";

export function PageHeader({ title, description, overline, actions, children, testid }) {
  return (
    <div className="border-b border-[var(--border)] bg-white" data-testid={testid}>
      <div className="max-w-[1400px] mx-auto px-8 py-6 flex items-end justify-between gap-6 flex-wrap">
        <div>
          {overline && <div className="overline mb-2">{overline}</div>}
          <h1 className="text-3xl font-medium tracking-tight">{title}</h1>
          {description && <p className="text-sm text-gray-600 mt-1.5 max-w-2xl">{description}</p>}
          {children}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}

export function Content({ children }) {
  return <div className="max-w-[1400px] mx-auto px-8 py-8">{children}</div>;
}

export function StatusBadge({ status = "draft" }) {
  return <span className={`badge-status ${status}`} data-testid={`status-${status}`}>{status}</span>;
}

export function EmptyState({ title, description, action, testid }) {
  return (
    <div className="card-flat p-12 text-center" data-testid={testid}>
      <div className="mx-auto w-14 h-14 rounded-full bg-[var(--muted)] grid place-items-center mb-5">
        <div className="w-6 h-6 border-2 border-dashed border-gray-400 rounded"></div>
      </div>
      <h3 className="text-lg font-medium tracking-tight">{title}</h3>
      {description && <p className="text-sm text-gray-600 mt-2 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
